import { render, staticRenderFns } from "./AssetEdit.vue?vue&type=template&id=c03b2fac"
import script from "./AssetEdit.vue?vue&type=script&lang=js"
export * from "./AssetEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports